<div class="container-card-config col-md-10 col-md-offset-1">
  <!-- Geral -->
  <div class="row">
    <div class="col-sm-6">
      <h3>
        <strong>Geral</strong>
      </h3>
    </div>
  </div>
  <div class="row m-0"></div>

  <app-card-geral></app-card-geral>
  <!-- Fim Geral -->

  <!-- Adquirentes -->
  <div class="row" *ngIf="conta.TipoCadastro !== 'PagueLa' && !isAdmin">
    <div class="col-sm-10">
      <h3>
        <strong>Adquirentes</strong>
        <span><span class="blue">Ative</span> o seu adquirente padrão para realizar transações</span>
      </h3>
    </div>
    <div class="col-sm-2">
      <button (click)="actionNovoAdquirente()" class="mt-20 pull-right btn btn-blue">+ Novo</button>
    </div>
  </div>

  <div class="msg-zero-rows" *ngIf="adquirentes && adquirentes.length === 0 && conta.TipoCadastro !== 'PagueLa'">
    <span>Você não tem nenhum adquirente cadastrado</span>
  </div>

  <div *ngIf="!isAdmin">
    <app-card-adquirente *ngFor="let adquirente of adquirentes" (event)="eventListenerAdquirentes($event)" [adquirenteInput]="adquirente"></app-card-adquirente>
  </div>
  <!-- Fim Adquirentes -->

  <!-- Cedentes -->
  <div class="row" *ngIf="cedentes && cedentes.length > 0 && !isAdmin">
    <div class="col-sm-12">
      <h3>
        <strong>Cedentes</strong>
        <span><span class="blue">Ative</span> o seu cedente padrão para emissão de boleto</span>
      </h3>
    </div>
  </div>

  <div *ngIf="!isAdmin">
    <app-card-cedente *ngFor="let cedente of cedentes" (event)="eventListenerCedentes($event)" [cedenteInput]="cedente"></app-card-cedente>
  </div>
  <!-- Fim Cedentes -->

  <!-- Alterar Senha -->
  <div class="row">
    <div class="col-sm-6">
      <h3>
        <strong>Alterar Senha</strong>
      </h3>
    </div>
  </div>

  <app-card-alterar-senha [conta]="conta"></app-card-alterar-senha>
  <!-- Fim Alterar Senha -->
</div>
